<template>
	<div id="dashboard" >
		<div v-if="loading" class="lds-dual-ring spinner"></div>

		<div v-show="loading == false">
			<h1>Welcome to modular</h1>

	

		
		
		</div>
		
		
	</div>	
</template>

<script>
	
	import general from '../../mixins/system/general'
	import axios from 'axios'


	export default {
		data() {
			return {
				tasks: [],
				user: [],
				loading: true,
			}
		},
		created() {

			this.getDashBoard()
		},
		methods: {
			getDashBoard() {

				axios.get(this.$store.getters.getDomainName+'dashboard')
				
				.then(response => {
					console.log(response.data)
					this.user = response.data.user
					
			this.loading = false;

				})
				.catch(error => {

				})
			}
		},
		mixins: [general],


	}
</script>

<style scoped>
body {

}
.user-rank {
	font-size: 12px;
	color:;
}
.section-block {
	background: #fff;
	padding: 30px;
	margin: 15px 0;
	box-shadow: 0px 6px 30px rgba(0,0,0,.1);
	border-radius: 3px;
}
.title-steps {
	position: relative;
	font-size: 21px;
	margin-left: 15px;
}

.welcome-block {
	height:250px;
	width: 100%;


}
.welcome-block-right {
	background: url(https://d2n6cmh8j179w8.cloudfront.net/3be75189-e1f6-4543-b13b-ed2bb40c0024/svg/cloud-web.svg) no-repeat;
	background-size: cover;

}
.user-info h2 {
	font-size: 20px;
	
}
.user-info img {
	float: left;
	height: 100px;
	margin: 0 auto;
}
h1 {
	font-size:21px;
	margin-bottom: 15px;
}
#dashboard {
	border-radius: 3px;
	background: #fbfbfb;
}
.item-block-dashboard {
}
.card-text {
	color:#8f8f8f;
	margin: 15px;
}
.item-block p {
	color: #145388;
	height: 48px;
	line-height: 18px;
}
.icons-dashboarad {
	color: #145388;
	margin-bottom: 0;
	font-size: 1.6rem;

}
.user-info h2 {
	padding-top: 30px;
}
.ul-user-info li {
	display: inline-block;
	color: #304455;
	color: #777;
	font-size: 13px;
}
.money-value {
	font-size:20px;
}
/*! CSS Used from: https://dore-jquery.coloredstrategies.com/font/iconsmind-s/css/iconsminds.css */

</style>


// WEBPACK FOOTER //
// src/components/pages/home.vue